import { render, staticRenderFns } from "./AlertJson.vue?vue&type=template&id=bbffc7a0&scoped=true&"
import script from "./AlertJson.vue?vue&type=script&lang=js&"
export * from "./AlertJson.vue?vue&type=script&lang=js&"
import style0 from "./AlertJson.vue?vue&type=style&index=0&id=bbffc7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbffc7a0",
  null
  
)

export default component.exports